/* bc-rambo-page.js — behaviour for the Rambo-style product page sections
   (bc-rambo-specs / bc-rambo-battery / bc-rambo-compare) and the buy-box extras
   (photo colour swatches, delivery timeline). Several sections include this file;
   it runs once and delegates on document so late (AJAX) buy-box blocks still work. */
(function () {
  'use strict';
  if (window.__bcrPage) return;
  window.__bcrPage = true;

  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };
  function qs(s, c) { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    try { if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, theme.moneyFormat || '${{amount}}').replace(/\.00$/, ''); } catch (e) {}
    return '$' + Math.round(cents / 100).toLocaleString('en-US');
  }
  function lock(on) { document.documentElement.classList.toggle('bcr-lock', on); document.body.classList.toggle('bcr-lock', on); }

  /* ---------- video lightbox ---------- */
  function embedFor(url) {
    try {
      var u = new URL(url);
      if (u.hostname.indexOf('youtu.be') > -1) return 'https://www.youtube.com/embed/' + u.pathname.replace('/', '') + '?autoplay=1&rel=0';
      if (u.hostname.indexOf('youtube.com') > -1) { var id = u.searchParams.get('v'); return id ? 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0' : ''; }
      if (u.hostname.indexOf('vimeo.com') > -1) { var p = u.pathname.split('/').filter(Boolean); return 'https://player.vimeo.com/video/' + p[p.length - 1] + '?autoplay=1'; }
    } catch (e) {}
    return '';
  }
  function lightbox() {
    var lb = qs('#bcrLightbox');
    if (lb) return lb;
    lb = document.createElement('div');
    lb.id = 'bcrLightbox';
    lb.innerHTML = '<div class="bcr-lb__overlay" data-bcr-lb-close></div><div class="bcr-lb__dialog" role="dialog" aria-modal="true" aria-label="Video"><button type="button" class="bcr-lb__close" data-bcr-lb-close aria-label="Close">&times;</button><div class="bcr-lb__content"></div></div>';
    var st = document.createElement('style');
    st.textContent = '#bcrLightbox{position:fixed;inset:0;z-index:9999;display:none}#bcrLightbox.is-open{display:block}.bcr-lb__overlay{position:absolute;inset:0;background:rgba(0,0,0,.85)}.bcr-lb__dialog{position:relative;z-index:2;width:min(960px,calc(100% - 32px));margin:6vh auto;background:#000;border-radius:14px;overflow:hidden;box-shadow:0 25px 80px rgba(0,0,0,.5)}.bcr-lb__close{position:absolute;top:10px;right:10px;z-index:3;width:42px;height:42px;border:0;border-radius:50%;background:rgba(255,255,255,.15);color:#fff;font-size:28px;line-height:1;cursor:pointer}.bcr-lb__content{aspect-ratio:16/9;background:#000}.bcr-lb__content iframe,.bcr-lb__content video{width:100%;height:100%;display:block;border:0}html.bcr-lock,body.bcr-lock{overflow:hidden}';
    document.head.appendChild(st);
    document.body.appendChild(lb);
    return lb;
  }
  function openVideo(url) {
    var lb = lightbox(), c = qs('.bcr-lb__content', lb), src = embedFor(url);
    if (src) c.innerHTML = '<iframe src="' + src + '" title="Video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    else if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(url)) c.innerHTML = '<video controls autoplay playsinline><source src="' + url + '"></video>';
    else { window.open(url, '_blank'); return; }
    lb.classList.add('is-open'); lock(true);
  }
  /* image preview: tap any marked image, it lifts into a dimmed, blurred backdrop */
  function imageBox() {
    var ib = qs('#bcrImageBox'); if (ib) return ib;
    ib = document.createElement('div'); ib.id = 'bcrImageBox';
    ib.innerHTML = '<div class="bcr-ib__overlay" data-bcr-ib-close></div><figure class="bcr-ib__fig"><button type="button" class="bcr-ib__close" data-bcr-ib-close aria-label="Close">&times;</button><img alt=""><figcaption></figcaption></figure>';
    var st = document.createElement('style');
    st.textContent = '#bcrImageBox{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;padding:24px}#bcrImageBox.is-open{display:flex}.bcr-ib__overlay{position:absolute;inset:0;background:rgba(10,10,10,.78);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);opacity:0;transition:opacity .25s}#bcrImageBox.is-in .bcr-ib__overlay{opacity:1}.bcr-ib__fig{position:relative;z-index:2;margin:0;max-width:min(1100px,100%);max-height:100%;display:flex;flex-direction:column;align-items:center;transform:translateY(16px) scale(.96);opacity:0;transition:transform .3s cubic-bezier(.2,.8,.2,1),opacity .3s}#bcrImageBox.is-in .bcr-ib__fig{transform:none;opacity:1}.bcr-ib__fig img{max-width:100%;max-height:82vh;display:block;box-shadow:0 30px 80px rgba(0,0,0,.6);border-bottom:4px solid #E3B123;background:#111}.bcr-ib__fig figcaption{color:#fff;font:600 14px Inter,sans-serif;margin-top:12px;letter-spacing:.02em;text-align:center}.bcr-ib__close{position:absolute;top:-14px;right:-14px;width:40px;height:40px;border:0;border-radius:50%;background:#E3B123;color:#000;font-size:26px;line-height:1;cursor:pointer;z-index:3}html.bcr-lock,body.bcr-lock{overflow:hidden}';
    document.head.appendChild(st); document.body.appendChild(ib); return ib;
  }
  function openImage(src, caption) {
    var ib = imageBox(), img = qs('img', ib); if (!src) return;
    img.src = src; qs('figcaption', ib).textContent = caption || '';
    ib.classList.add('is-open'); lock(true);
    requestAnimationFrame(function () { setTimeout(function () { ib.classList.add('is-in'); }, 10); });
  }
  function closeImage() { var ib = qs('#bcrImageBox'); if (!ib) return; ib.classList.remove('is-in'); setTimeout(function () { ib.classList.remove('is-open'); qs('img', ib).src = ''; lock(false); }, 260); }
  /* ---------- info modal ----------
     Opens any hidden block in the description by id, so a page can explain something long
     (a Pro-Build, a warranty, a fitting) behind a link instead of bloating the copy.
     Trigger:  <a data-bcr-info="bcrProBuild">What is a Pro-Build?</a>
     Content:  <div id="bcrProBuild" hidden> … </div>   (anywhere in the description) */
  function infoBox() {
    var ifb = qs('#bcrInfoBox'); if (ifb) return ifb;
    ifb = document.createElement('div'); ifb.id = 'bcrInfoBox';
    ifb.innerHTML = '<div class="bcr-if__overlay" data-bcr-if-close></div><div class="bcr-if__dialog" role="dialog" aria-modal="true" aria-labelledby="bcrInfoTitle"><button type="button" class="bcr-if__close" data-bcr-if-close aria-label="Close">&times;</button><div class="bcr-if__body"></div></div>';
    var st = document.createElement('style');
    st.textContent = '#bcrInfoBox{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center;padding:20px}#bcrInfoBox.is-open{display:flex}.bcr-if__overlay{position:absolute;inset:0;background:rgba(10,10,10,.78);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);opacity:0;transition:opacity .25s}#bcrInfoBox.is-in .bcr-if__overlay{opacity:1}.bcr-if__dialog{position:relative;z-index:2;width:min(620px,100%);max-height:86vh;overflow:auto;background:#fff;border-radius:14px;border-bottom:4px solid #E3B123;box-shadow:0 30px 80px rgba(0,0,0,.55);transform:translateY(16px) scale(.97);opacity:0;transition:transform .3s cubic-bezier(.2,.8,.2,1),opacity .3s}#bcrInfoBox.is-in .bcr-if__dialog{transform:none;opacity:1}.bcr-if__body{padding:30px 28px 26px}.bcr-if__close{position:absolute;top:10px;right:12px;width:36px;height:36px;border:0;border-radius:50%;background:#f1f1f1;color:#111;font-size:24px;line-height:1;cursor:pointer;z-index:3}.bcr-if__close:hover{background:#E3B123}.bcr-if__body h3{font:800 20px/1.25 Bebas Neue,Inter,sans-serif;letter-spacing:.02em;margin:0 0 4px;text-transform:uppercase}.bcr-if__body .bcr-if__price{display:inline-block;font:800 14px Inter,sans-serif;background:#5f7038;color:#fff;border-radius:4px;padding:3px 10px;margin:0 0 14px}.bcr-if__body p{font:400 14px/1.65 Inter,sans-serif;color:#333;margin:0 0 12px}.bcr-if__body ul{margin:0 0 14px;padding-left:20px}.bcr-if__body li{font:400 14px/1.6 Inter,sans-serif;color:#333;margin-bottom:7px}.bcr-if__body .bcr-if__note{font-size:13px;color:#555;border-left:3px solid #E3B123;padding:9px 13px;background:#faf7ef;margin:0}@media(max-width:600px){.bcr-if__body{padding:26px 20px 22px}}';
    document.head.appendChild(st); document.body.appendChild(ifb); return ifb;
  }
  function openInfo(id) {
    var src = document.getElementById(id); if (!src) return;
    var ifb = infoBox();
    qs('.bcr-if__body', ifb).innerHTML = src.innerHTML;
    ifb.classList.add('is-open'); lock(true);
    requestAnimationFrame(function () { setTimeout(function () { ifb.classList.add('is-in'); }, 10); });
    var c = qs('.bcr-if__close', ifb); if (c) c.focus();
  }
  function closeInfo() {
    var ifb = qs('#bcrInfoBox'); if (!ifb) return;
    ifb.classList.remove('is-in');
    setTimeout(function () { ifb.classList.remove('is-open'); qs('.bcr-if__body', ifb).innerHTML = ''; lock(false); }, 260);
  }
  function closeVideo() { var lb = qs('#bcrLightbox'); if (!lb) return; qs('.bcr-lb__content', lb).innerHTML = ''; lb.classList.remove('is-open'); lock(false); }

  /* ---------- cart helper ---------- */
  function addVariant(id, btn, label) {
    btn.disabled = true; var old = btn.textContent; btn.textContent = 'ADDING…';
    fetch(root() + 'cart/add.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: 'form_type=product&id=' + encodeURIComponent(id) + '&quantity=1' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () { btn.textContent = label || 'ADDED ✓'; btn.disabled = false; qsa('.cart-link__bubble').forEach(function (b) { b.classList.add('cart-link__bubble--visible'); }); })
      .catch(function () { btn.textContent = 'TRY AGAIN'; btn.disabled = false; setTimeout(function () { btn.textContent = old; }, 2000); });
  }

  /* ---------- battery selector ---------- */
  function battInit(wrap) {
    if (wrap.__init) return; wrap.__init = true;
    var sel = qs('[data-bcr-batt-select]', wrap), ph = qs('[data-bcr-placeholder]', wrap);
    function show(handle) {
      var any = false;
      qsa('.bcr-batt__details', wrap).forEach(function (d) {
        var on = d.getAttribute('data-bike') === handle && handle;
        d.hidden = !on; if (on) { any = true; carousel(d); }
      });
      if (ph) ph.hidden = any;
    }
    function carousel(d) {
      if (d.__car) return; d.__car = true;
      var track = qs('[data-bcr-track]', d), cards = qsa('.bcr-batt__card--up', d), dots = qs('[data-bcr-dots]', d), i = 0;
      if (!track || !cards.length) return;
      dots.innerHTML = cards.map(function () { return '<i></i>'; }).join('');
      function go(n) { i = (n + cards.length) % cards.length; track.style.transform = 'translateX(-' + (i * 100) + '%)'; qsa('i', dots).forEach(function (x, k) { x.classList.toggle('active', k === i); }); }
      qs('[data-bcr-prev]', d).addEventListener('click', function () { go(i - 1); });
      qs('[data-bcr-next]', d).addEventListener('click', function () { go(i + 1); });
      go(0);
    }
    sel.addEventListener('change', function () { show(this.value); });
    /* Pick the bike this page is about: exact handle first, then the longest bike NAME that
       appears in the handle or title (so a duplicate like `test-copy-...-savage-2-0`, or a
       long SEO title, still lands on the right bike instead of an empty selector). */
    var cur = (wrap.getAttribute('data-current') || '').toLowerCase();
    var title = (wrap.getAttribute('data-title') || document.title || '').toLowerCase();
    var opt = cur && sel.querySelector('option[value="' + cur + '"]');
    if (!opt) {
      var best = null, bestLen = 0;
      qsa('option', sel).forEach(function (o) {
        if (!o.value) return;
        var n = o.textContent.trim().toLowerCase(), slug = n.replace(/[^a-z0-9]+/g, '-');
        if ((cur.indexOf(slug) > -1 || title.indexOf(n) > -1) && n.length > bestLen) { best = o; bestLen = n.length; }
      });
      opt = best;
    }
    if (!opt && sel.options.length === 2) opt = sel.options[1];
    if (opt) { sel.value = opt.value; show(opt.value); }
  }
  /* "option:Battery Size=20Ah" — the upgrade is a choice ON this bike, not a separate product,
     so ordering it means selecting that option and taking the shopper to the buy button. */
  function selectOption(spec, btn) {
    var parts = spec.replace(/^option:/, '').split('=');
    var name = (parts[0] || '').trim().toLowerCase(), val = (parts[1] || '').trim().toLowerCase();
    var hit = qsa('.variant-input').filter(function (vi) {
      var wrap = vi.closest('.variant-input-wrap');
      var optName = (wrap && (wrap.getAttribute('name') || '')).toLowerCase();
      return optName === name && (vi.getAttribute('data-value') || '').trim().toLowerCase() === val;
    })[0];
    if (!hit) return false;
    var input = qs('input', hit);
    if (input && !input.checked) { input.click(); }
    var form = qs('.product-single__title') || qs('[data-product-blocks]');
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (btn) { var old = btn.textContent; btn.textContent = '✓'; setTimeout(function () { btn.textContent = old; }, 2200); }
    return true;
  }
  function battCard(card, plus) {
    var d = card.closest('.bcr-batt__details'), panel = qs('[data-bcr-panel]', d);
    var vid = card.getAttribute('data-variant');
    if (plus && vid && vid.indexOf('option:') === 0) { selectOption(vid, plus); return; }
    if (plus && vid) { addVariant(vid, plus, '✓'); return; }
    qs('[data-bcr-panel-name]', panel).textContent = card.getAttribute('data-name');
    qs('[data-bcr-panel-price]', panel).textContent = card.getAttribute('data-price');
    qs('[data-bcr-panel-desc]', panel).textContent = card.getAttribute('data-desc');
    var img = qs('[data-bcr-panel-img]', panel), src = card.getAttribute('data-image');
    if (src) { img.src = src; img.style.display = ''; } else img.style.display = 'none';
    /* No CALL fallback (Nelson 2026-09-14). `vid` is either a variant id or an
       `option:Name=Value` selector; with neither, hide the button rather than offer a phone call. */
    var add = qs('[data-bcr-add]', panel), call = qs('[data-bcr-call]', panel);
    add.hidden = !vid; add.setAttribute('data-variant', vid || '');
    if (call) call.hidden = true;
    add.textContent = vid && vid.indexOf('option:') === 0 ? 'CHOOSE THIS BATTERY' : 'ADD TO CART';
    panel.hidden = !(panel.hidden || panel.getAttribute('data-for') !== card.getAttribute('data-name'));
    panel.setAttribute('data-for', card.getAttribute('data-name'));
  }

  /* ---------- compare table ---------- */
  /* compare prices keep their cents: $5,799.00, matching how Rambo prints them */
  function priceStr(cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function compareInit(wrap) {
    if (wrap.__init) return; wrap.__init = true;
    var data; try { data = JSON.parse(qs('[data-bcr-compare-data]', wrap).textContent); } catch (e) { return; }
    /* Sale Price always comes from Shopify, never the saved JSON — Collective can reprice any day */
    var liveEl = qs('[data-bcr-live-prices]', wrap), live = {};
    try { live = JSON.parse((liveEl || {}).textContent || '{}'); } catch (e) {}
    (data.bikes || []).forEach(function (b, i) {
      var h = (b.url || '').replace('/products/', '').split('?')[0], L = live[h];
      if (!L) return;
      (data.groups || []).forEach(function (g) {
        (g.rows || []).forEach(function (r) {
          /* Nelson, 2026-09-19: NO sold-out label in the compare table. `L.available` is true if ANY
             variant is buyable, so the flag could only ever say "every size is gone" — and it stayed
             silent while the size a shopper actually wants was out. A half-true badge on someone
             else's column is worse than none. Price still comes from Shopify live. */
          if (r.label === 'Sale Price') r.values[i] = priceStr(L.price);
        });
      });
    });
    var bikes = data.bikes || [], groups = data.groups || [], visible = data.visible_groups || 2;
    /* lead with the bike whose page this is, so the same table works on every Rambo product */
    var here = wrap.getAttribute('data-current') || '';
    var mine = -1;
    /* A column stands for a MODEL, but a page is one colourway or one build of it. `match` lists the
       other handles the column represents (State's 4130 Road v2 has three colourways; the All-Road
       has a 12-speed and an AXS build). Without it a bike falls back to the first three columns,
       which only looks right when its model happens to be first. Rambo has no `match` and is
       unaffected. */
    bikes.forEach(function (b, i) {
      if (!here) return;
      var h = (b.url || '').replace('/products/', '').split('?')[0];
      if (h === here || (b.match || []).indexOf(here) > -1) mine = i;
    });
    /* A page that is another BUILD of its column's model shows its OWN price there, not the canonical
       bike's. 2026-09-25: the $3,399.99 Carbon All-Road AXS page read $2,399.99 (the 1x12's price) in its
       own column, as did every AXS / 1x13 build. The cell stays blank until /products/<here>.js answers;
       if that fails (a draft product 404s) it falls back to the canonical bike's live price. */
    var own = '';
    if (mine > -1 && here && (bikes[mine].url || '').replace('/products/', '').split('?')[0] !== here) own = here;
    if (own) groups.forEach(function (g) { (g.rows || []).forEach(function (r) {
      if (r.label === 'Sale Price') r.values[mine] = '';
    }); });
    var start = [0, 1, 2];
    if (mine > 0) { start = [mine].concat([0, 1, 2].filter(function (i) { return i !== mine; }).slice(0, 2)); }
    /* State (2026-09-14): one table serves the whole line, so a bike opens beside its own family
       (bike.family, e.g. "4130") before anything else. Bikes without a family keep the order above. */
    if (mine > -1 && bikes[mine] && bikes[mine].family) {
      var fam = bikes[mine].family, kin = [], rest = [];
      bikes.forEach(function (b, i) { if (i === mine) return; (b.family === fam ? kin : rest).push(i); });
      start = [mine].concat(kin, rest).slice(0, 3);
    }
    /* OPTIONAL bike.peers (2026-09-29, Nelson: the Titanium All-Road AXS page should open beside the standard
       Titanium All-Road "so they know the main difference"). Names listed in the page's own column follow it
       directly; the remaining slots keep the family order above. No column carries peers unless set, so every
       other page opens exactly as before. */
    if (mine > -1 && bikes[mine] && (bikes[mine].peers || []).length) {
      var pi = [];
      bikes[mine].peers.forEach(function (n) { bikes.forEach(function (b, i) { if (b.name === n && i !== mine && pi.indexOf(i) < 0) pi.push(i); }); });
      start = [mine].concat(pi, start.filter(function (i) { return i !== mine && pi.indexOf(i) < 0; }),
        bikes.map(function (b, i) { return i; }).filter(function (i) { return i !== mine && pi.indexOf(i) < 0; })).filter(function (v, k, a) { return a.indexOf(v) === k; }).slice(0, 3);
    }
    var sels = qsa('select[data-bcr-col]', wrap), cols = start.slice();
    /* 2026-10-06 (Ausom, two scooters): a table with fewer bikes than columns shows only as many columns as it
       has bikes, instead of repeating the last bike under an empty picker. Tables with 3+ bikes are unchanged. */
    if (bikes.length < sels.length) {
      cols = cols.slice(0, bikes.length);
      sels.forEach(function (s, k) {
        if (k < bikes.length) return;
        /* removed, not hidden: a hidden <col> still holds its width and left an empty band beside the table */
        [s.closest('th'), (qs('[data-bcr-img="' + k + '"]', wrap) || {}).parentNode, qs('[data-bcr-name="' + k + '"]', wrap),
         qsa('colgroup col', wrap)[bikes.length + 1]]
          .forEach(function (el) { if (el && el.parentNode) el.parentNode.removeChild(el); });
      });
      sels = sels.slice(0, bikes.length);
    }
    sels.forEach(function (s, k) {
      s.innerHTML = bikes.map(function (b, i) { return '<option value="' + i + '">' + b.name + '</option>'; }).join('');
      s.value = String(Math.min(cols[k], bikes.length - 1)); cols[k] = Number(s.value);
      s.addEventListener('change', function () { cols[k] = Number(this.value); render(); });
    });
    var hl = qs('[data-bcr-highlight]', wrap); hl.addEventListener('change', render);
    /* Liquid's all_products lookup is capped at 20 per page; past the cap it hands back a stale
       product, so the JSON above can carry the WRONG price (2026-09-24 audit: $420.69 on a $2,799.99
       Carbon Road). Re-read every price from /products/<handle>.js, which has no such cap. */
    function livePrice(i, h, fallback) {
      fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p || typeof p.price !== 'number') { if (fallback) livePrice(i, fallback); return; }
        groups.forEach(function (g) { (g.rows || []).forEach(function (r) {
          if (r.label === 'Sale Price') r.values[i] = priceStr(p.price) + (p.available ? '' : '|OOS');
        }); });
        render();
      }).catch(function () { if (fallback) livePrice(i, fallback); });
    }
    bikes.forEach(function (b, i) {
      var h = (b.url || '').replace('/products/', '').split('?')[0];
      if (!h || !window.fetch) return;
      if (i === mine && own) livePrice(i, own, h); else livePrice(i, h);
    });
    var body = qs('[data-bcr-body]', wrap);
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }
    function render() {
      cols.forEach(function (bi, k) {
        var b = bikes[bi] || {};
        var img = qs('[data-bcr-img="' + k + '"]', wrap);
        if (b.image) { img.src = b.image; img.alt = b.name || ''; img.style.display = ''; img.setAttribute('data-bcr-zoom', b.image); img.setAttribute('data-bcr-caption', b.name || ''); }
        else { img.removeAttribute('src'); img.style.display = 'none'; img.removeAttribute('data-bcr-zoom'); }
        qs('[data-bcr-name="' + k + '"]', wrap).textContent = b.name || '';
      });
      var html = '';
      groups.forEach(function (g, gi) {
        var extra = gi >= visible ? ' is-extra' : '';
        html += '<tr class="bcr-compare__group' + extra + '"><td colspan="' + (cols.length + 1) + '">' + esc(g.title) + '</td></tr>';
        (g.rows || []).forEach(function (r) {
          var vals = cols.map(function (bi) { return (r.values || [])[bi] || ''; });
          var diff = hl.checked && vals.some(function (v) { return v !== vals[0]; });
          html += '<tr class="bcr-compare__row' + extra + (diff ? ' is-diff' : '') + '"><th class="bcr-compare__sticky">' + esc(r.label) + '</th>' + vals.map(function (v) {
            var oos = v.indexOf('|OOS') > -1; if (oos) v = v.replace('|OOS', '');
            return '<td>' + esc(v).replace(/UPGRADE:/g, '<br><strong>UPGRADE:</strong>') + (oos ? '<span class="bcr-compare__oos">Sold out</span>' : '') + '</td>';
          }).join('') + '</tr>';
        });
      });
      body.innerHTML = html;
      var more = qs('[data-bcr-more]', wrap); if (more) more.parentNode.style.display = groups.length > visible ? '' : 'none';
    }
    render();
  }

  /* ---------- buy box: photo swatches + delivery timeline ---------- */
  function swatches() {
    var mapEl = qs('#bcrColorMap'); if (!mapEl) return;
    var map; try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    qsa('input.variant__input--color-swatch').forEach(function (inp) {
      var lab = qs('label[for="' + inp.id + '"]'); if (!lab || lab.__bcr) return;
      var src = map[inp.value]; if (!src) return;
      lab.__bcr = true; lab.classList.add('bcr-swatch');
      var im = document.createElement('img'); im.src = src; im.alt = ''; im.loading = 'lazy';
      lab.insertBefore(im, lab.firstChild);
    });
  }
  /* Option pills: "15Ah · 720Wh · up to 65 mi" + "+$300" — computed from the variants, notes from custom.option_notes */
  function optionNotes() {
    var vEl = qs('#bcrVariants'); if (!vEl) return;
    var variants, notes = {};
    try { variants = JSON.parse(vEl.textContent) || []; } catch (e) { return; }
    try { notes = JSON.parse((qs('#bcrOptionNotes') || {}).textContent || 'null') || {}; } catch (e) {}
    var minAll = Math.min.apply(null, variants.map(function (v) { return v.price; }));
    qsa('.variant-input-wrap').forEach(function (wrap) {
      var optName = wrap.getAttribute('name'), idx = Number((wrap.getAttribute('data-index') || 'option1').replace('option', '')) - 1;
      qsa('.variant-input', wrap).forEach(function (vi) {
        var val = vi.getAttribute('data-value'), lab = qs('label', vi);
        if (!lab || lab.__bcrNote) return; lab.__bcrNote = true;
        var prices = variants.filter(function (v) { return v.options[idx] === val; }).map(function (v) { return v.price; });
        if (!prices.length) return;
        var delta = Math.min.apply(null, prices) - minAll;
        var note = (notes[optName] || {})[val];
        if (note) { var n = document.createElement('span'); n.className = 'bcr-note'; n.textContent = note; lab.appendChild(n); }
        if (delta > 0) { var d = document.createElement('span'); d.className = 'bcr-delta'; d.textContent = '+' + money(delta); lab.appendChild(d); }
      });
    });
  }
  /* Wheel rig: the front wheel turns with the page. Scrolling adds spin; friction lets it drift to a stop. */
  function wheelRig() {
    qsa('[data-bcr-wheelrig]:not([data-ready])').forEach(function (rig) {
      rig.setAttribute('data-ready', '1');
      var disc = qs('[data-bcr-disc]', rig); if (!disc) return;
      if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var gain = parseFloat(rig.getAttribute('data-gain')) || 0.35, angle = 0, vel = 0, lastY = window.scrollY, running = false, lastT = 0;
      function frame(t) {
        var dt = Math.min(48, t - lastT || 16); lastT = t;
        angle += vel * (dt / 16.7); vel *= Math.pow(0.93, dt / 16.7);
        disc.style.transform = 'rotate(' + angle.toFixed(2) + 'deg)';
        if (Math.abs(vel) > 0.02) requestAnimationFrame(frame); else running = false;
      }
      function kick(dy) { dy = Math.max(-140, Math.min(140, dy)); /* an anchor jump is one nudge, not a whirl */ vel += dy * gain * 0.12; vel = Math.max(-28, Math.min(28, vel)); if (!running) { running = true; lastT = 0; requestAnimationFrame(frame); } }
      window.addEventListener('scroll', function () { var y = window.scrollY, dy = y - lastY; lastY = y; var r = rig.getBoundingClientRect(); if (r.bottom < -200 || r.top > innerHeight + 200) return; kick(dy); }, { passive: true });
      /* a small nudge when it first comes into view, so the wheel reads as alive before anyone scrolls */
      if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { kick(60); io.disconnect(); } }); }, { threshold: 0.4 }); io.observe(rig); }
    });
  }
  function timeline() {
    qsa('[data-bcr-timeline]:not([data-ready])').forEach(function (t) {
      t.setAttribute('data-ready', '1');
      var d = new Date(), f = function (x) { return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }, add = function (n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; };
      var s = (t.getAttribute('data-days') || '1,3,5,6').split(',').map(Number);
      qs('[data-d0]', t).textContent = f(d);
      qs('[data-d1]', t).textContent = f(add(s[0])) + ' - ' + f(add(s[1]));
      qs('[data-d2]', t).textContent = f(add(s[2])) + ' - ' + f(add(s[3]));
    });
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var ctab = t.closest('[data-bcr-comp-tab]');
    if (ctab) { compShow(ctab.closest('[data-bcr-comp]'), +ctab.getAttribute('data-bcr-comp-tab')); return; }
    var cstep = t.closest('[data-bcr-comp-step]');
    if (cstep) { var cw = cstep.closest('[data-bcr-comp]'), cn = qsa('[data-bcr-comp-panel]', cw).length;
      compShow(cw, (compCurrent(cw) + (+cstep.getAttribute('data-bcr-comp-step')) + cn) % cn); return; }
    var acc = t.closest('[data-bcr-acc]');
    if (acc) { setAcc(acc, acc.getAttribute('aria-expanded') !== 'true'); return; }
    /* the three green buttons: glide to the section instead of jumping; Specification also unfolds its table on arrival */
    var jump = t.closest('.bcr-btn[href^="#"]');
    if (jump) {
      var target = qs(jump.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var hdr = qs('.site-header, [data-sticky-header], .header-sticky'), off = 0;
        if (hdr) { var hp = getComputedStyle(hdr).position; if (hp === 'fixed' || hp === 'sticky') off = hdr.getBoundingClientRect().height; }
        /* a sticky button row (ausom-2027) would cover the section it jumps to; clear it too */
        var jsec = jump.closest('.shopify-section'); if (jsec && getComputedStyle(jsec).position === 'sticky') off += jsec.getBoundingClientRect().height;
        var top = target.getBoundingClientRect().top + window.scrollY - off - 8;
        var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', jump.getAttribute('href'));
        if (jump.getAttribute('href') === '#specification') {
          /* the anchor now sits on the spec table itself, so the bar may BE the target */
          var bar = qs('[data-bcr-acc]', target) || (target.hasAttribute('data-bcr-acc') ? target : qs('#specification [data-bcr-acc]'));
          if (bar) setTimeout(function () { setAcc(bar, true); }, reduce ? 0 : 650);
        }
      }
      return;
    }
    var v = t.closest('[data-bcr-video]'); if (v) { openVideo(v.getAttribute('data-bcr-video')); return; }
    var yt = t.closest('[data-bcr-yt]');
    if (yt) {
      /* swap the thumbnail for the player only now — nothing from YouTube loads until this click */
      var id = yt.getAttribute('data-bcr-yt');
      yt.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1&iv_load_policy=3" title="Review video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      yt.setAttribute('aria-label', 'Playing'); return;
    }
    if (t.closest('[data-bcr-lb-close]')) { closeVideo(); return; }
    if (t.closest('[data-bcr-ib-close]')) { closeImage(); return; }
    if (t.closest('[data-bcr-if-close]')) { closeInfo(); return; }
    var inf = t.closest('[data-bcr-info]'); if (inf) { e.preventDefault(); openInfo(inf.getAttribute('data-bcr-info')); return; }
    var zi = t.closest('[data-bcr-zoom]'); if (zi) { e.preventDefault(); openImage(zi.getAttribute('data-bcr-zoom') || zi.currentSrc || zi.src, zi.getAttribute('data-bcr-caption') || zi.alt); return; }
    var plus = t.closest('.bcr-batt__plus'); if (plus) { battCard(plus.closest('.bcr-batt__card'), plus); return; }
    var card = t.closest('.bcr-batt__card--up'); if (card) { battCard(card, null); return; }
    var add = t.closest('[data-bcr-add]');
    if (add && add.getAttribute('data-variant')) {
      var av = add.getAttribute('data-variant');
      if (av.indexOf('option:') === 0) { selectOption(av, add); } else { addVariant(av, add, 'ADDED ✓'); }
      return;
    }
    var more = t.closest('[data-bcr-more]'); if (more) { var w = more.closest('[data-bcr-compare]'); var x = w.classList.toggle('is-expanded'); more.setAttribute('aria-expanded', String(x)); more.firstChild.textContent = x ? 'View less ' : 'View more '; return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeVideo(); closeImage(); closeInfo(); } });

  /* Tap feedback on the variant pills. CSS alone cannot confirm a CHOICE: :active ends the
     moment the finger lifts, and the picked state is easy to miss on a small screen. So the
     pill the shopper just chose gets a one-shot pulse. Runs on real changes only, never on
     page load, and the label is the input's next sibling in the theme's markup. */
  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp || inp.type !== 'radio' || !inp.closest || !inp.closest('.variant-input-wrap')) return;
    var lab = inp.nextElementSibling;
    if (!lab || lab.tagName !== 'LABEL') return;
    lab.classList.remove('bcr-tapped');
    void lab.offsetWidth;                 /* restart the animation if the same pill is re-picked */
    lab.classList.add('bcr-tapped');
    setTimeout(function () { lab.classList.remove('bcr-tapped'); }, 600);
  }, true);
  /* clear coat: no drag, no right-click save on coated images */
  document.addEventListener('contextmenu', function (e) { if (e.target.closest && e.target.closest('.bcr-coat, [data-bcr-coated]')) e.preventDefault(); });
  document.addEventListener('dragstart', function (e) { if (e.target.closest && e.target.closest('.bcr-coat, [data-bcr-coated]')) e.preventDefault(); });


  /* ---------- State: fit & size ----------
     Pills swap a per-size geometry table. Data is the JSON script inside the block; rows past
     data-bcs-limit hide behind a View-all button. Ported from sections/bc-state-fit.liquid so the
     block can come from the product description. Idempotent per block. */
  function fitInit(root) {
    if (root.__init) return; root.__init = true;
    var raw = qs('[data-bcs-fit-data]', root), data;
    try { data = JSON.parse(raw ? raw.textContent : '{}'); } catch (e) { return; }
    var sizes = data.sizes || [], rows = data.rows || [];
    if (!sizes.length) { root.style.display = 'none'; return; }
    var pills = qs('.bcs-fit__pills', root), body = qs('[data-bcs-rows]', root), rider = qs('[data-bcs-rider]', root),
        cap = qs('[data-bcs-cap]', root), more = qs('[data-bcs-more]', root);
    var limit = parseInt(root.getAttribute('data-bcs-limit'), 10); if (!(limit > 0)) limit = 5;
    var total = 0;
    function label() {
      if (!more) return;
      var open = root.getAttribute('data-expanded') === '1';
      more.textContent = open ? 'Show less' : 'View all ' + total + ' measurements';
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function paint(i) {
      qsa('.bcs-fit__pill', pills).forEach(function (b, n) { b.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      rider.textContent = sizes[i].rider ? 'Fits riders ' + sizes[i].rider : '';
      cap.textContent = sizes[i].size;
      var html = '', shown = 0;
      for (var r = 0; r < rows.length; r++) {
        var lab = rows[r][0], vals = rows[r][1] || [];
        if (vals[i] == null) continue;
        html += '<tr' + (shown >= limit ? ' class="is-extra"' : '') + '><td>' + lab + '</td><td>' + vals[i] + '</td></tr>';
        shown++;
      }
      body.innerHTML = html; total = shown;
      if (more) { more.hidden = shown <= limit; label(); }
    }
    sizes.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bcs-fit__pill'; b.textContent = s.size; b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { paint(i); });
      pills.appendChild(b);
    });
    if (more) more.addEventListener('click', function () {
      root.setAttribute('data-expanded', root.getAttribute('data-expanded') === '1' ? '0' : '1'); label();
    });
    /* open on the middle size: the one most riders land on, and it shows the table populated */
    paint(Math.floor(sizes.length / 2));
  }


  /* ---------- crossfading story row ----------
     Two or more photos in one row, swapped on a timer. Ported from the old State page's
     bike-fade-swap. Two rules kept from it: the timer only advances while the row is actually on
     screen (IntersectionObserver), and prefers-reduced-motion opts out entirely rather than
     snapping between frames. Idempotent per row. */
  function fadeInit(box) {
    if (box.__init) return; box.__init = true;
    var imgs = qsa('.bcr-fade__img', box);
    if (imgs.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var iv = parseInt(box.getAttribute('data-interval'), 10) || 5000, i = 0, vis = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { vis = e.isIntersecting; });
      }, { threshold: 0.1 }).observe(box);
    }
    setInterval(function () {
      if (!vis) return;
      imgs[i].classList.remove('is-on');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('is-on');
    }, iv);
  }


  /* "What is it made of?" tabs (2026-10-08, Ausom). Only the [data-bcr-comp] markup the `components`
     config key emits uses this; no other page has it. */
  function compShow(w, i) {
    if (!w) return;
    qsa('[data-bcr-comp-tab]', w).forEach(function (b) {
      var on = +b.getAttribute('data-bcr-comp-tab') === i;
      b.classList.toggle('is-on', on); b.setAttribute('aria-selected', String(on));
      if (on) { var row = b.parentNode; if (row.scrollWidth > row.clientWidth) row.scrollTo({ left: b.offsetLeft - (row.clientWidth - b.offsetWidth) / 2, behavior: 'smooth' }); }
    });
    qsa('[data-bcr-comp-panel]', w).forEach(function (p) { p.classList.toggle('is-on', +p.getAttribute('data-bcr-comp-panel') === i); });
  }
  function compCurrent(w) { var on = qs('[data-bcr-comp-tab].is-on', w); return on ? +on.getAttribute('data-bcr-comp-tab') : 0; }

  function setAcc(bar, open) {
    bar.setAttribute('aria-expanded', String(open));
    var body = bar.nextElementSibling; if (!body) return;
    body.classList.toggle('is-open', open);
    body.setAttribute('aria-hidden', String(!open));
  }
  function init() {
    /* quantity stepper beside Add to Cart (Nelson, 2026-09-14). The theme renders quantity as
       its own block above the form; move it into the ATC row so they share a line. The input
       keeps its form="" attribute, so the cart still receives it. Idempotent. */
    (function () {
      var q = document.querySelector('.product__quantity'), row = document.querySelector('.product-form__atc-row');
      if (!q || !row || row.contains(q)) return;
      var blk = q.closest('.product-block');
      row.insertBefore(q, row.firstChild);
      if (blk && !blk.textContent.trim() && !blk.querySelector('img,button,input')) blk.classList.add('bcr-qty-moved');
    })();
    qsa('[data-bcr-battery]').forEach(battInit);
    qsa('[data-bcr-compare]').forEach(compareInit);
    qsa('[data-bcs-fit]').forEach(fitInit);
    qsa('[data-bcr-fade]').forEach(fadeInit);
    swatches(); optionNotes(); timeline(); wheelRig();
  }
  var tries = 0, timer = setInterval(function () { tries++; init(); if (tries > 40) clearInterval(timer); }, 250);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
